import globalWindow from '@utils/globals';
import { useEffect } from 'react';

export const useStorageChange = (onChange: () => void) => {
  useEffect(() => {
    const handler = () => {
      onChange();
    };
    globalWindow.addEventListener?.('storage', handler);
    return () => {
      globalWindow.removeEventListener?.('storage', handler);
    };
  }, [onChange]);
};
